// extracted by mini-css-extract-plugin
export default {"emptyTabContents":"pTs1yPQpvr0ayXlorCZbgGZXBJeQ4rzE","emptyTabContentsTitle":"vbcVyJpEdztPq0oBNgOioA9BAXNj1MEL","emptyTabContentsText":"IIPdzqoWP13ul1NTL9bZPgKnInkDAMbL"};